module.exports = __webpack_public_path__ + "img/1592073764.a4817f5b.jpg";